import { useEffect } from 'react';
import '@n8n/chat/style.css';
import "../styles/Bot.scss";
import { createChat } from '@n8n/chat';

export const Bot = () => {
	useEffect(() => {
		createChat({
            webhookUrl: 'https://n8n-ovit-production.up.railway.app/webhook/97b3d612-1213-4288-b722-05f4577e9ab7/chat',
            webhookConfig: {
                method: 'POST',
                headers: {}
            },
            target: '#n8n-chat',
            mode: 'window',
            chatInputKey: 'chatInput',
            chatSessionKey: 'sessionId',
            metadata: {},
            showWelcomeScreen: false,
            defaultLanguage: 'en',
            initialMessages: [
                'Hola 👋 Soy tu asistente virtual. Escríbenos para cotizaciones o dudas. Estoy a la orden.😃',
            ],
            i18n: {
                en: {
                    title: '¡Bienvenido a LUVITEC!',
                    subtitle: "Estamos listos para ayudarte a resolver tus dudas 24/7.",
                    footer: '',
                    getStarted: 'New Conversation',
                    inputPlaceholder: 'Escribe tu pregunta..',
                },
            },
        });
	}, []);

	return (<div></div>);
};

export default Bot;